import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import { BLOB_CONTENT_TYPE, CONTENT_TYPE, JSON_CONTENT_TYPE } from "../common";
export function defaultResponseHandler(response) {
  if (204 === response.status) return _Promise.resolve(null);
  var contentType = response.headers.get(CONTENT_TYPE);
  return contentType && _includesInstanceProperty(contentType).call(contentType, JSON_CONTENT_TYPE) ? response.json() : contentType && _includesInstanceProperty(contentType).call(contentType, BLOB_CONTENT_TYPE) ? response.blob() : response.text();
}